export const OWNER_SETUP_COPY = {
  smtp: {
    headline: "Send email from this installation",
    body: "SMTP sends invites and magic codes. The owner password login works without it.",
    save: "Save and continue",
    saving: "Saving…",
    skip: "Skip for now",
    host: "SMTP host",
    port: "SMTP port",
    username: "SMTP username",
    password: "SMTP password",
    fromName: "From name",
    fromEmail: "From email",
    useTls: "Use TLS (STARTTLS)",
    useTlsHelp: "Encrypt the connection to the SMTP server.",
    required: "Enter the SMTP host, port, and from email.",
    error: "SuperPlane could not save SMTP settings. Check the values and try again.",
  },
  fleet: {
    headline: "Set up runner fleets",
    body: "Connect runners to this installation. Install Fleet Manager on a cloud account.",
    helper: "The next page shows the install command. You can skip this and set up fleets later.",
    continue: "Set up fleets",
    skip: "Skip for now",
  },
  closeError: "SuperPlane could not close setup.",
  closeRetry: "Try again",
} as const;
